var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4554_5534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 -0.000976562C6.2685 -0.000976562 0 6.26752 0 13.999C0 21.7305 6.2685 27.999 14 27.999C21.7315 27.999 28 21.7305 28 13.999C28 6.26752 21.7315 -0.000976562 14 -0.000976562ZM20.8763 9.59019L18.578 20.4169C18.4088 21.1845 17.9515 21.3712 17.3133 21.0095L13.8133 18.4312L12.1263 20.0575C11.963 20.2675 11.7098 20.4017 11.4263 20.4017C11.424 20.4017 11.4228 20.4017 11.4205 20.4017L11.669 16.8387L18.1557 10.9797C18.4357 10.7312 18.0927 10.59 17.7205 10.8385L9.70667 15.8855L6.25333 14.8075C5.50667 14.5707 5.48567 14.0609 6.41083 13.6945L19.9045 8.49352C20.5322 8.26486 21.0782 8.64286 20.8752 9.59136L20.8763 9.59019Z",
    fill: "url(#paint0_linear_5143_5404)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5143_5404",
    x1: 3.5,
    y1: 2.52778,
    x2: 26.8333,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E470AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#7230FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4554_5534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.65a8a0abdef3c3a543eb171e1d9442f7.svg";
export { ForwardRef as ReactComponent };